// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__kQ5O-","button":"Pagination_button__tba7j","icon":"Pagination_icon__CfE3Q","numbers":"Pagination_numbers__PFJrm","num":"Pagination_num__8Lvbc"};